<template>
  <section class="company-page">
    <company-header :h1Content="h1Content" />
    <company-info :introContent="introContent" />
    <company-buttons :products="products" />
    <app-question-panel
      class="mt-16"
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :questions="questions"
    />
  </section>
</template>

<script>
import companyHeader from '@/component/company/CompanyHeader'
import companyInfo from '@/component/company/CompanyInfo'
import appQuestionPanel from '@/component/expansional-question-panel/AppQuestionPanel'
import companyButtons from '@/component/company/CompanyButtons'

export default {
  metaInfo: {
    title: 'Quick Sigorta Fiyatları İçin Teklif Alın, Karşılaştırın',
    meta: [
      {
        name: 'description',
        content:
          "Quick Sigorta'dan fiyat teklifi alarak karşılaştırma yapın, en iyi sigorta planlarına online ulaşın. Quick Sigorta Güvencesi ile poliçenizi satın alın."
      }
    ]
  },
  name: 'QuickSigorta',
  components: {
    companyHeader,
    companyInfo,
    appQuestionPanel,
    companyButtons
  },
  data () {
    return {
      h1Content: 'Quick Sigorta Fiyatları',
      faqTitle: 'Quick Sigorta Hakkında Merak Edilen Sorular',
      faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
      products: {
        title: 'Quick Sigorta Ürünleri',
        buttons: [
          {
            id: 1,
            title: 'TRAFİK SİGORTASI',
            class: 'company--btn--icons fas fa-car fa-2x mr-2',
            path: 'QuickSigortaCompulsoryTraffic'
          },
          {
            id: 2,
            title: 'KASKO SİGORTASI',
            class: 'company--btn--icons fas fa-car-crash fa-2x mr-2',
            path: 'QuickSigortaMotorInsurance'
          },
          {
            id: 3,
            title: 'DASK SİGORTA',
            class: 'company--btn--icons fas fa-laptop-house  fa-2x mr-2',
            path: 'QuickSigortaDaskInsurance'
          },
          {
            id: 4,
            title: 'KONUT SİGORTASI',
            class: 'company--btn--icons fas fa-house-damage fa-2x mr-2',
            path: 'QuickSigortaHomeInsurance'
          },
          {
            id: 5,
            title: 'İŞYERİ SİGORTASI',
            class: 'company--btn--icons fas fa-building  fa-2x mr-2',
            path: 'QuickSigortaCompanyInsurance'
          },
          {
            id: 6,
            title: 'FERDİ KAZA SİGORTASI',
            class: 'company--btn--icons fas fa-user-injured fa-2x mr-2',
            path: 'QuickSigortaPersonalInsurance'
          },
          {
            id: 7,
            title: 'NAKLİYAT SİGORTASI',
            class: 'company--btn--icons fas fa-luggage-cart fa-2x mr-2',
            path: 'QuickSigortaTransportationInsurance'
          },
          {
            id: 8,
            title: 'KEFALET SİGORTASI',
            class: 'company--btn--icons fas fa-pencil-alt fa-2x mr-2',
            path: 'QuickSigortaSuretyInsurance'
          },
          {
            id: 9,
            title: 'ALACAK SİGORTASI',
            class: 'company--btn--icons fas fa-credit-card fa-2x mr-2',
            path: 'QuickSigortaCreditInsurance'
          },
          {
            id: 10,
            title: 'SEYAHAT SAĞLIK SİGORTASI',
            class: 'company--btn--icons fas fa-umbrella-beach fa-2x mr-2',
            path: 'QuickSigortaTravelInsurance'
          }
        ]
      },
      introContent: {
        title: 'Quick Sigorta Hakkında',
        content: [
          {
            paragraph:
              'Quick Sigorta A.Ş. Türkiye’de tamamen %100 yerli sermaye ile kurulmuş sigorta şirketlerindendir. Menşei Türkiye olan sigorta şirketi Maher Holding A.Ş. iştirakidir. 61.900.000 TL sermaye ile başlayıp tamamı ödenmiştir. 2018 yılı The Digital Insurer Global Lıvefest (Küresel Dijital Sigorta Şirketleri) Avrupa Birincisi olan sigorta şirketi birçok alanında ödüle sahiptir. '
          },
          {
            paragraph:
              'Yeni hizmetler konusunda öncü olmak üzere faaliyet gösteren sigorta şirketi sağlamış olduğu ayrıcalıklarla sigorta şirketleri arasında güvenilen ve tercih edilen şirketi olarak tanınmaktadır. Dijital sigortacılığın öncüsü olarak ilerlemeyi kendine vizyon edinen şirket, çözüm odaklı, pratik, hızlı ve kaliteli hizmet verme yolunda da işlemlerine emin adımlarla devam etmektedir. Quick Sigorta sigortalılarını kısa sürede güvence altına alan sigorta şirketidir. '
          },
          {
            paragraph:
              'Sigorta teminatları içinde ekstra sunmuş olduğu hediyeler ile müşterileri memnuniyetini maksimum orana taşımaktadır. Yerli sermaye ile kurulan sigorta şirketi, hayat sigortaları dışında tüm sigorta dallarında, ekstra teminat paketleri ile kanunlara uygun olarak alınan tüm izinler kapsamında faaliyetini sürdürmektedir.'
          }
        ]
      },
      questions: [
        {
          title: 'Quick Sigorta Ürün Çeşitleri Nelerdir?',
          content: [
            {
              paragraph:
                'Quick Sigorta’dan teklif almak isteyen tüm müşterilerimiz <strong><em><u>alokasko.com </u></em></strong> sayfamızdan minimum fiyat avantajları ile maksimum teminatlı avantajlı tekliflere ulaşabilir.',
              subList: null
            },
            {
              paragraph:
                'Quick Sigorta Alokasko’nun anlaşmalı olduğu sigorta şirketlerindendir. Şirketimiz bünyesinde size özel teklif verebileceğimiz sigorta ürünlerimiz;',
              subList: [
                'Trafik Sigortası',
                'Araç Kasko Sigortası',
                'DASK (Zorunlu Deprem Sigortası)',
                'Konut Sigortası',
                'İşyeri Sigortası',
                'Ferdi Kaza Sigortası',
                'Kefalet Sigortası',
                'Alacak Sigortası',
                'Nakliyat Sigortası',
                'Seyahat Sağlık Sigortası'
              ]
            },
            {
              paragraph:
                'Quick Sigorta’nın hizmet verdiği tüm sigorta branşlarda ihtiyaç duyduğunuz ürünler için sigorta uzmanlarımızdan fiyat teklifi isteyebilirsiniz. ',
              subList: null
            }
          ]
        },
        {
          title: 'Quick Sigorta Zorunlu Trafik Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Quick Sigorta Zorunlu Trafik Sigortası ile trafikte yapmış olduğunuz kazalarda kusurlu olmanız durumunda üçüncü şahısların zararları teminat altına alınır.',
              subList: null
            },
            {
              paragraph:
                "Trafikte zarar gören üçüncü kişilerin maddi ve bedeni zararlarını karşılayabilmeniz için trafik sigortası yaptırmanız kanunen zorunludur. Trafik sigortası paketlerini avantajlı hale getiren Quick Sigorta,  90 TL'ye trafik sigortası teminatlarını ikiye katlama fırsatı sunuyor. ",
              subList: null
            },
            {
              paragraph:
                'Quick Sigorta ek olarak <strong><em><u>Ferdi Kaza</u></em></strong> ve <strong><em><u>Hukuksal Koruma Teminatları</u></em></strong>nı da poliçe kapsamında sunmaktadır. Zorunlu trafik sigortası teminatları her yıl Devlet Hazine Müsteşarlığı tarafından belirlenmektedir. ',
              subList: null
            }
          ]
        },
        {
          title: 'Quick Sigorta Araç Kasko Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Quick Sigorta Araç Kasko Sigortası aracınızın uğrayacağı zarar ve hasarları güvence altına almaktadır. Sunulan farklı paketler sayesinde ihtiyacınıza ve bütçenize uygun kasko poliçesini satın alabilirsiniz.',
              subList: null
            },
            {
              paragraph:
                'Kasko çeşitleri kapsamında 4 farklı plan bulunmaktadır:',
              subList: ['Tam Kasko', 'Geniş Kasko', 'Kasko', 'Dar Kasko']
            },
            {
              paragraph:
                '** Her planın kasko teminatları ve sunulan hizmetleri farklılık göstermektedir. Bu sebeple kasko primleri de her poliçede değişecektir. Aracınızın kullanım şekline göre değerlendirmeli ve en doğru poliçeyi satın almalısınız. ',
              subList: null
            }
          ]
        },
        {
          title: 'Quick Sigorta DASK – Zorunlu Deprem Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Quick DASK, zorunlu deprem sigortası ile depremin neden olabileceği maddi zararları ve deprem sonucunda oluşacak yangın, infilak, yer kayması ve tsunami gibi hasarlara karşı evinizi güvence altına alabilirsiniz. ',
              subList: null
            },
            {
              paragraph:
                'Zorunlu deprem sigortası hesaplamalarında poliçe primi konutların yapı tarzı ve hangi deprem risk bölgesinde yer aldığı göz önünde bulundurularak hesaplanır. ',
              subList: null
            },
            {
              paragraph: 'Hasarsız geçen her yılsonunda yenilenen poliçeden;',
              subList: [
                'Birinci, ikinci ve üçüncü yenilemelerinizde %10, ',
                'Dördüncü yenilemelerinizden sonra ise %20 indirim hakkı kazanırsınız.'
              ]
            },
            {
              paragraph:
                'İndirim hakkından yararlanmak için DASK poliçenize 30 gün içinde yenilemelisiniz.',
              subList: null
            }
          ]
        },
        {
          title: 'Quick Sigorta Konut Sigortası Nedir?',
          content: [
            {
              paragraph:
                '<strong>Quick Konut Sigortası</strong>, konutunuzda ve eşyalarınızda oluşabilecek zararları güvence altına alan sigorta poliçesidir. İster ev sahibi olun ister kiracı konut paket sigortasından yararlanabilirsiniz.',
              subList: null
            },
            {
              paragraph: 'Quick Sigorta Konut Sigortası İle:',
              subList: [
                'Kombi Bakımı ',
                'Klima Bakımı',
                'Halı Yıkama Hizmetlerinden de faydalanabilirsiniz.'
              ]
            },
            {
              paragraph: 'Konut sigortası hesaplamalarında;',
              subList: [
                'Bina Yaşı',
                'Yapı Tipi',
                'Binada Bulunan Toplam Kat Sayısı / Konutun Bulunduğu Kat',
                'Yüz Ölçümü, Merdiven Dairesi Yüz Ölçümü',
                'Dış Cephe Çeşidi',
                'Tapudaki Pafta, Parsel Bilgisi dikkate alınmaktadır.'
              ]
            },
            {
              paragraph:
                'En uygun konut sigortası fiyatını almak için başvuru formunu doldurmanız yeterlidir.',
              subList: null
            }
          ]
        },
        {
          title: 'Quick Sigorta İşyeri Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Quick Sigorta ile işyerinizi de güvence altına alabilirsiniz. İşyeriniz, gelir kaynağınızdır. En doğru teminatları belirleyerek satın alacağınız işyerinize ve bütçenize maksimum fayda sağlar.',
              subList: null
            },
            {
              paragraph:
                'İşyeri sigortası, işyerinizi ve işyerinizdeki aklınıza gelebilecek her türlü demirbaş eşya, emtia, makine, tesisat gibi varlıklarınızın alabileceği her türlü zarar durumu güvence altına alınır. Yangın, hırsızlık, deprem, sel-su baskını gibi tüm doğal afetlerden kaynaklı, iş durması, çalışamama, hizmete ara verilmesi, kira kaybı, sorumlu olunan kişilere karşı ve daha birçok riske karşı güvence sağlayan sigorta türüdür.',
              subList: null
            }
          ]
        },
        {
          title: 'Quick Sigorta Ferdi Kaza Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Quick Sigorta Ferdi Kaza Sigortası gündelik hayatta karşılaşabileceğiniz ve kaza nedeniyle oluşabilecek maddi kayıpları teminat altına alır. Ürünün bir avantajı da motosiklet, yelkencilik, avcılık, , kayak, dalış, dağcılık gibi outdoor aktivitelerine de güvence sağlamasıdır.',
              subList: null
            },
            {
              paragraph:
                '<strong><em><u>Quick Ferdi Kaza Sigortası Teminatları;</u></em></strong>',
              subList: [
                'Vefat Teminatı',
                'Daimi Maluliyet Teminatı',
                'Gündelik Teminat ',
                'Tedavi Masrafları Teminatı'
              ]
            },
            {
              paragraph:
                'Ferdi Kaza sigortası teminatlarından faydalanabilmeniz için oluşan kazanın, sigorta kapsamındaki kişinin ani veya kendi iradesi dışında gelişmiş olmasıyla birlikte bir olayın harici etkisiyle meydana gelen bedensel zarar görmesi sonucunda olmuş olması gerekir. ',
              subList: null
            },
            {
              paragraph:
                'Ferdi kaza sigortaları 1 yıllık olarak düzenlenir. Poliçelerin belirli yıllık ödemeleri vardır. Ödemeler belirli kişisel özelliklere göre değişiklik gösterirken, poliçeye eklenen, talep edilen teminatlara göre de değişiklik gösterir. ',
              subList: null
            },
            {
              paragraph:
                'Teminat limitlerinin belirlenmesinde, sigortalının yaşı, mesleki özellikleri göz önünde bulundurularak belirli esaslar dahilinde netleşir. Ödenecek tazminat miktarı önceden poliçe tarafları arasında uzlaşma ile yapılır.',
              subList: null
            }
          ]
        },
        {
          title: 'Quick Sigorta Kefalet Sigortası Nedir?',
          content: [
            {
              paragraph:
                '4734 Sayılı Kamu İhale Kanundaki değişiklik ile şirketlerin ihalelere katılırken kullandıkları banka teminat mektubu yerine kefalet sigortası kapsamında düzenlenmiş kefalet senetlerini sunmaları gibi bir imkan tanınmıştır. ',
              subList: null
            },
            {
              paragraph:
                'İhaleler için teminat mektubu olarak Türkiye’de bulunan sigorta şirketleri ile kefalet sigortası kapsamında oluşturulan kefalet senetlerinin de kullanılabileceği düzenlenmiştir. Günümüzde şirketler için kredi limitlerinin daha da önemli olmasından dolayı, Quick Sigorta’nın sunduğu Kefalet Sigortası ve bağlı olduğu senetleri özel sektörün teminat ihtiyaçlarını karşılamasında yeni ve ekstra kapasite oluşturmuştur.',
              subList: null
            },
            {
              paragraph:
                'Kefalet sigortası satın almak isteyen şirketlerin <strong><em><u>alokasko.com</u></em></strong> uzman sigortacılarına bilgi vermeleri yeterlidir. Gerekli evrak ve bilgiler ile ihtiyacınız en hızlı şekilde giderilecektir.',
              subList: null
            }
          ]
        },
        {
          title: 'Quick Sigorta Alacak Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Alacak sigortası ticari borçların ödenmeme riskine karşı teminat sunmaktadır. Hazine ve Maliye Bakanlığı’nın başlatmış olduğu yeni Devlet Destekli Alacak Sigorta modeli KOBİ’ler için alacaklarını garanti altına almaktadır. Bu sigorta KOBİ’lerin alacaklarını tahsil etmekte zorlandıkları durumlar için, alacaklarının önemli kısmını Devlet Destekli Alacak Sigortası Havuzundan karşılar.',
              subList: null
            },
            {
              paragraph:
                'Sunulan alacak sigortası teklifinizi 10 gün içinde onaylamanız durumunda sorgulama ücreti alınmaz.',
              subList: null
            },
            {
              paragraph:
                'Poliçeler 120, 180,240 veya 360 güne kadar vadeli satışlara teminat sağlanmaktadır. Primleri taksitli ödeyebileceğiniz gibi peşinde ödeyebilirsiniz. Quick Sigorta peşin ödemelerde %10 indirim sağlamaktadır.',
              subList: null
            }
          ]
        },
        {
          title: 'Quick Sigorta Nakliyat Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Quick Sigorta Nakliyat Emtea Sigortası, taşınan herhangi bir yükün, onun taşınmaya uygun karayolu, denizyolu, havayolu ve demiryolu nakil için kullanılan vasıtalarla bir yerden farklı bir yere taşınması sırasında uğrayabileceği hasar ve kayıpları karşı güvence sağlar. ',
              subList: null
            },
            {
              paragraph:
                'Poliçede belirlenmiş teminatları Nakliyat Sigortası Genel Şartlar ve Özel Şartlar kapsamı ile güvence altına alan sigorta ürünüdür.',
              subList: null
            }
          ]
        },
        {
          title: 'Quick Sigorta Seyahat Sağlık Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Quick Seyehat Sağlık Sigortası, yurtiçi ve yurtdışı seyahatlerinizde oluşabilecek her türlü kaza, yaralanma, tedavi giderleri, hastalık nedeni ile nakil, vefat eden sigortalının nakli, kaybolan bagajların bulunması, bulunan bagajların sigortalıya ulaşımı ve yolculuk sırasında oluşabilecek tüm zorluklara karşı güvence altına alan sigorta ürünüdür.',
              subList: null
            },
            {
              paragraph:
                'Seyahat sağlık sigortası ürünü aynı zamanda, girişte vize koyan tüm ülkelerin, vize kontrol işlemi sırasında istedikleri zorunlu bir sigorta ürünüdür. Gidilecek ülke ve kalınacak gün sayısına bağlı olarak poliçe süresi ve poliçe primi belirlenir. ',
              subList: null
            },
            {
              paragraph:
                'Peşin ve taksitli ödeme seçenekleri seyahat sağlık sigortası kapsamında mevcuttur. Seyahate çıkmadan önce <strong><em><u>alokasko.com</u></em></strong> sigorta danışmanlarına bilgi vermeniz durumunda güvenceniz başlatılır.',
              subList: null
            }
          ]
        },
        {
          title: 'Quick Sigorta Poliçe Sorgulama Nasıl Yapılır?',
          content: [
            {
              paragraph:
                'Quick Sigorta poliçe sorgulaması yapmak isteyen sigortalıların, Quick Sigorta sitesinden online işlemler menüsüne giriş yapması gerekmektedir. Bu alanda yer alan “<strong>Üye İşlemleri</strong>” adımından “<strong>Poliçelerim</strong>” sekmesine tıklayarak giriş yapabilir ve poliçelerim sayfasına erişebilirsiniz.',
              subList: null
            },
            {
              paragraph:
                '** AloKasko uzmanlarından satın aldığınız poliçelerinizi 0216 371 67 77 numaralı hattı arayarak sigorta danışmanınıza sorgulatabilirsiniz.',
              subList: null
            }
          ]
        },
        {
          title: 'Quick Sigorta Hasar Dosya Sorgulama Nasıl Yapılır?',
          content: [
            {
              paragraph:
                'Quick Sigorta hasar dosya sorgulaması yapmak isteyen sigortalılar sigorta şirketinin resmi web sitesini ziyaret etmelidir. Site kategorilerinden “Online İşlemler” menüsüne giriş yaparak aşağıdaki başlıklara ulaşabilirsiniz.',
              subList: null
            },
            {
              paragraph: '<strong>HASAR İŞLEMLERİ:</strong>',
              subList: [
                'Hasar Bildir',
                'Hasar Dosya Sorgulama',
                'Anlaşmalı Servisler',
                'Değer Kaybı Başvurusu ',
                'Kusur Durumuna İtiraz'
              ]
            },
            {
              paragraph:
                '** Sigorta poliçesini <strong><em><u>alokasko.com</u></em></strong> uzmanlarından satın alan adaylar hasar sorgulamasını uzmanlarımız aracılığıyla yaparak, işlemlerinizi hızlandırabilir.',
              subList: null
            }
          ]
        },
        {
          title: 'Quick Sigorta Poliçe Fiyatı Nasıl Alınır?',
          content: [
            {
              paragraph:
                'Quick Sigorta poliçe fiyatı almak için teklif formumuzu doldurabilir ve en uygun sigorta fiyatlarını karşılaştırabilirsiniz.',
              subList: null
            }
          ]
        }
      ]
    }
  }
}
</script>
